import { useEffect } from 'react';
import PropTypes from 'prop-types';

import { useLocation } from 'react-router-dom';

import { usePrevious } from 'shared/hooks';
import { wasOnlyModalOpenOrClosed } from 'shared/Modal';

function AutoScroll({ autoScrollToTop, loading }) {
  const location = useLocation();
  const prevLocation = usePrevious(location) || {};

  useEffect(() => {
    const { hash } = location;
    const elementName = hash.replace('#', '').replace(/_/g, '-');

    let retries = 0;

    const scrollToAnchor = () => {
      retries += 0;
      if (retries > 50) return;

      const element = document.getElementById(elementName);

      if (element) {
        setTimeout(() => {
          const offset = 20;
          const elementPosition = window.pageYOffset + element.getBoundingClientRect().top;
          const targetPosition = elementPosition - offset;

          window.scrollTo({ top: targetPosition, behavior: 'smooth' });
        }, 0);
      } else {
        setTimeout(scrollToAnchor, 100);
      }
    };

    if ((hash === '') && autoScrollToTop) {
      if (!wasOnlyModalOpenOrClosed(location, prevLocation) || loading) {
        const scrollBehavior = (
          location.pathname !== prevLocation.pathname
          || loading
        ) ? 'auto' : 'smooth';

        window.scrollTo({ top: 0,  behavior: scrollBehavior });
      }
    } else {
      scrollToAnchor();
    }
  }, [location, loading]);

  return null;
}

AutoScroll.defaultProps = {
  autoScrollToTop: true,
  location: {},
  loading: false
};

AutoScroll.propTypes = {
  autoScrollToTop: PropTypes.bool,
  location: PropTypes.object,
  loading: PropTypes.bool
};

export default AutoScroll;
